export abstract class CosmoBaseModel {
  etag?: string | null | undefined;
}
